let mapper_options = {
  endpoint: 'facebook_shares',
  recordClass: require('./record'),
  relations: {
    belongsTo: {
      retailer: {
        foreignKey: 'retailer_id',
        localField: 'retailer'
      },
      share_setting: {
        foreignKey: 'share_setting_id',
        localField: 'share_setting'
      }
    }
  }
}

module.exports = (store) => {
  store.defineMapper('facebook_share', mapper_options)
}
